import Http from '@/utils/http'
const baseUrl = '/app/student'

export const mockInfo = classChapterId => Http.get(`${baseUrl}/chapter/mock/${classChapterId}` )

export const submit = data => Http.post(`${baseUrl}/chapter/mock`, data)